export const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ADVISOR":
      return action.advisor;
    case "UPDATE_ADVISOR_FIELD":
      return { ...state, ...action.field };
    case "CRM_CONNECTED":
      return { ...state, connectCrm: action.connectCrm };
    default:
      return state;
  }
};
export default reducer;
